<template>
  <div class="tab">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in tabList"
        :key="item.label + index"
        :label="item.label"
        :name="String(item.name)"
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'tab',
  props: {
    tabList: Array,
  },
  data() {
    return {
      activeName: '',
      isGroup: false,
    };
  },
  mounted() {
    this.activeName = this.tabList[0].name;
  },
  methods: {
    handleClick() {
      this.$emit('tabClick', this.activeName);
    },
  },
};
</script>
<style lang="scss">
.tab {
  .el-tabs__item {
    line-height: 48px;
  }
}
</style>
